import { Link } from "react-router-dom";

interface BrandLockupProps {
  size?: "sm" | "lg";
}

export default function BrandLockup({ size = "sm" }: BrandLockupProps): JSX.Element {
  if (size === "sm") {
    return (
      <Link to="/" className="flex items-center gap-2.5 font-display text-lg">
        <img src="/logo-512.png" alt="" aria-hidden="true" className="w-8 h-8 rounded-md" />
        <span>
          <span className="text-fg">FLEX </span>
          <span className="text-brand-emphasis">FUND</span>
        </span>
      </Link>
    );
  }
  return (
    <div className="flex items-center gap-6">
      <span className="af-shine inline-block w-[120px] h-[120px]">
        <img
          src="/logo-512.png"
          alt=""
          aria-hidden="true"
          className="w-full h-full rounded-2xl"
          style={{ filter: "drop-shadow(0 0 24px rgb(var(--brand) / 0.45))" }}
        />
      </span>
      <span
        aria-hidden="true"
        className="w-px h-[100px]"
        style={{
          background: "linear-gradient(to bottom, transparent, rgb(var(--border-strong)), transparent)",
        }}
      />
      <span className="font-display leading-[0.9]" style={{ fontSize: "clamp(48px, 5vw, 80px)" }}>
        <span className="block text-fg">FLEX</span>
        <span className="block text-brand-emphasis">FUND</span>
      </span>
    </div>
  );
}
